<div class="project-details-content">
  <!-- Header -->
  <div class="header">
    <div class="title">Project Settings</div>
    <div class="description">Project details and parameters</div>
    <div class="button-actions">
      @if ((permissions | includesBy: 'project:update')) {
        <div class="button secondary button-icon" [matMenuTriggerFor]="projectSettingsMenu">
          <mat-icon svgIcon="settings" class="icon"></mat-icon>
        </div>
        <mat-menu #projectSettingsMenu="matMenu" xPosition="before">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="openC3Stations()">C3 Stations</button>
            <button mat-menu-item (click)="deleteProject()" style="color: red;">Delete</button>
          </ng-template>
        </mat-menu>
      }
    </div>
  </div>

  <!-- Record Settings -->
  @if (currentProject) {
    <div class="record-settings" [class.disabled]="!(permissions | includesBy: 'project:update')">

      <!-- Title -->
      <div class="line">
        <div class="row">
          <div class="project-logo" (click)="importFile.click()">
            <img class="image" [src]="currentProject.photoUrl || 'https://archive.org/download/placeholder-image/placeholder-image.jpg'" />
          </div>
          <input type="file" (change)="uploadImage($event)" hidden #importFile>
        </div>
        <div class="row">
          <div class="title">Name</div>
          <input class="input" [(ngModel)]="currentProject.name" (blur)="updateProject()">
        </div>
      </div>

      <!-- ID -->
      @if (currentProject.id) {
        <div class="row">
          <div class="project-id">{{ currentProject.id }}</div>
        </div>
      }

      <!-- Start Trigger -->
      @if (currentProject.startTrigger) {
        <div class="line">
          <div class="row">
            <div class="title">Start Trigger</div>
            <app-select class="select" [options]="recordOptions.startTrigger" [selected]="currentProject.startTrigger.type" (selectedChange)="updateStartTrigger($event)"></app-select>
          </div>
          @if (currentProject.startTrigger.type === 'timecode') {
            <div class="divider"></div>
            <div class="row">
              <div class="title">Timecode</div>
              <input class="input" [(ngModel)]="currentProject.startTrigger.value" (blur)="updateProject()">
            </div>
          }
        </div>
      }

      <!-- Destinations -->
      <div class="row">
        <div class="title">
          <div>Destinations</div>
          @if (permissions | includesBy: 'project:update') {
            <div class="button-create">
              <mat-icon svgIcon="plus" class="icon" (click)="addDestination()"></mat-icon>
            </div>
          }
        </div>
        <div class="destinations">
          <div class="table-header keys">ID</div>
          <div class="table-header name">Name</div>
          <div class="table-header bucket">Bucket</div>
          <div class="table-header profile">Profile</div>
          <div class="table-header flags">Flags</div>
        </div>
        @for (destination of destinations; track destination.id) {
          <div class="destinations">
            <input class="input key" [disabled]="true" [(ngModel)]="destination.id">
            <input class="input name" [(ngModel)]="destination.name" (blur)="updateDestination()">
            <input class="input bucket" [(ngModel)]="destination.bucket" (blur)="updateDestination()">
            <input class="input profile" [(ngModel)]="destination.profile" (blur)="updateDestination()">
            <app-select class="select flags" [options]="recordOptions.destinationFlags" [selected]="destination.acl" (selectedChange)="updateDestinationFlags($event, destination.id)"></app-select>
            @if (permissions | includesBy: 'project:update') {
              <div class="button-delete">
                <mat-icon svgIcon="trash" class="icon" (click)="deleteDestination(destination.id)"></mat-icon>
              </div>
            }
          </div>
        }
      </div>

      <!-- Slack Notifications -->
      <div class="slack-card">
        <div class="slack-header">
          <mat-icon svgIcon="slack" class="icon"></mat-icon>
          <div class="text">
            <div class="title">Slack Notifications</div>
            <div class="description">Send a Slack webhook message on record lifecycle events</div>
          </div>
        </div>

        @for (field of slackNotificationFields; track field.key) {
          <div class="slack-group">
            <div class="slack-group-head">
              <span class="label">{{ field.title }}</span>
              @if (permissions | includesBy: 'project:update') {
                <div class="slack-add" (click)="addSlackUrl(field.key)">
                  <mat-icon svgIcon="plus" class="icon"></mat-icon>
                  <span>Add</span>
                </div>
              }
            </div>

            @for (url of currentProject.settings?.[field.key] ?? []; track $index) {
              <div class="slack-url">
                <input class="input"
                       [class.error]="url && !isSlackWebhookUrl(url)"
                       placeholder="https://hooks.slack.com/services/..."
                       [(ngModel)]="currentProject.settings![field.key]![$index]"
                       (blur)="trimSlackUrl(field.key, $index)"
                       (keyup.enter)="addSlackUrl(field.key)">
                @if (permissions | includesBy: 'project:update') {
                  <div class="button-delete">
                    <mat-icon svgIcon="trash" class="icon" (click)="removeSlackUrl(field.key, $index)"></mat-icon>
                  </div>
                }
              </div>
            } @empty {
              <div class="slack-empty">No webhooks configured</div>
            }
          </div>
        }
      </div>

    </div>

    <!-- Save -->
    @if (permissions | includesBy: 'project:update') {
      <div class="record-actions">
        <div class="button secondary" [class.disabled]="!editing" (click)="resetProjectChanges()">Reset</div>
        <div class="button" [class.disabled]="!editing" (click)="saveProject()">Save</div>
      </div>
    }

    <!-- Servers -->
     <div class="servers">
      @for (server of serverTemplates; track server.id) {
        <app-project-server
          class="server"
          [class.disabled]="!(permissions | includesBy: 'project:update')"
          [server]="server"
          [project]="currentProject"
        ></app-project-server>
      }
      @if (permissions | includesBy: 'project:update') {
        <div class="button secondary add-server" (click)="addServer()">Add Server</div>
      }
     </div>
  }

</div>